"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTable = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const StyledTable = components_core_1.styled.table `
  font-size: inherit;
  width: 100%;
  border-spacing: 0;
`;
function CustomTable({ children }) {
    return (react_1.default.createElement(StyledTable, { className: "table-container" },
        react_1.default.createElement("tbody", null, children)));
}
exports.CustomTable = CustomTable;
